import preval from 'preval.macro';
module.exports = require(preval`module.exports = process.env.REACT_APP_USE_FIXTURE !== '1' ? './relayEnv.js' : './relayEnv.mock.js'`);
